import rawFunds from "../dummyFunds.json";

export interface FundsCome {
  byoFundList: { name: string; code: string }[];

  ocpFundList: {
    name: string;
    code: string;
    lowerBound: number | null;
    upperBound: number | null;
    rangeText: string;
  }[];
}

interface FundsGo {
  byo: { fundName: string; fundCode: string }[];

  ocp: {
    fundName: string;
    fundCode: string;
    yearLowerBound?: number;
    yearUpperBound?: number;
    rangeText: string;
  }[];
}

const compareName = (a: any, b: any) => {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
};

export const fundListMap = (list: any[]) => {
  const fundList = { byoFundList: [{}], ocpFundList: [{}] };
  fundList.byoFundList = list.filter(
    (fund: any) => fund.shareClassStatus === "Open"
  );
  fundList.byoFundList = fundList.byoFundList.map((fund: any) => {
    return {
      name: fund.productName,
      code: fund.portfolioId
    };
  });
  fundList.byoFundList.sort(compareName);
  fundList.ocpFundList = rawFunds.ocpFundList;

  return fundList;
};

export const fundsApdatper = ({
  byoFundList,
  ocpFundList
}: FundsCome): FundsGo => {
  return {
    byo: byoFundList.map(item => {
      return {
        fundName: item.name,
        fundCode: item.code
      };
    }),
    ocp: ocpFundList.map(item => ({
      fundName: item.name,
      fundCode: item.code,
      yearLowerBound: item.lowerBound ? item.lowerBound : undefined,
      yearUpperBound: item.upperBound ? item.upperBound : undefined,
      rangeText: item.rangeText
    }))
  };
};
